(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["murano-black-november"] && !Shopify.designMode) return;
  try {
    
const initMuranoVip = (section) => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  section.querySelectorAll('[data-murano-sound]').forEach((button) => {
    const video = button.parentElement.querySelector('video');
    if (!video) { button.hidden = true; return; }
    button.addEventListener('click', () => {
      video.muted = !video.muted;
      video.volume = 1;
      video.play().catch(() => {});
      const audible = !video.muted;
      button.setAttribute('aria-pressed', String(audible));
      button.textContent = audible ? button.dataset.disableLabel : button.dataset.enableLabel;
    });
  });
  section.querySelectorAll('.murano-vip__media-rail, .murano-vip__reviews').forEach((rail) => {
    rail.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const card = rail.children[0];
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).gap || 0);
      rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * (card.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  });
  section.querySelectorAll('.murano-vip__faq-list details').forEach((item) => item.addEventListener('toggle', () => {
    if (!item.open) return;
    section.querySelectorAll('.murano-vip__faq-list details[open]').forEach((other) => { if (other !== item) other.open = false; });
  }));
  // With a Klaviyo form ID, the CTAs open the embedded form in a modal instead of following their links.
  const dialog = section.dataset.muranoForm && document.getElementById(section.dataset.muranoForm);
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const lockPage = (locked) => document.documentElement.classList.toggle('murano-vip-lock', locked);
  dialog.querySelector('[data-murano-form-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => lockPage(false));
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const packageCtas = document.querySelectorAll(`a[href="#${dialog.id}"]`);
  [...section.querySelectorAll('.murano-vip__header-cta, .murano-vip__hero-cta, .murano-vip__closing .murano-vip__button'), ...packageCtas].forEach((cta) => {
    cta.setAttribute('aria-haspopup', 'dialog');
    cta.setAttribute('aria-controls', dialog.id);
    cta.addEventListener('click', (event) => {
      event.preventDefault();
      if (dialog.open) return;
      dialog.showModal();
      lockPage(true);
    });
  });
};
document.querySelectorAll('[data-murano-vip]').forEach(initMuranoVip);
// Theme editor re-renders the section on every change; bind the new markup again.
document.addEventListener('shopify:section:load', (event) => {
  document.documentElement.classList.remove('murano-vip-lock');
  event.target.querySelectorAll('[data-murano-vip]').forEach(initMuranoVip);
});

  } catch(e) { console.error(e); }
})();
})();
